// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yWW8I","label":"styles_label__Z63pN","textarea":"styles_textarea__zu6TF","count":"styles_count__onv1H","error":"styles_error__CTwYl"};